import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import {
  SOCIAL_LOGIN_TYPE,
  TYPE_OF_LOGIN
} from 'src/utils/constants/localStorageConstants';

export const getAutomaticAgeRating = (
  countryList: Countrylist | undefined
): number | false => {
  if (!countryList) {
    return false;
  }
  const {
    automatic_pin_settings: { enabled = 'false', age_rating = null } = {}
  } = countryList;
  let automaticAgeRatingVal: number | false = false;

  if (enabled === 'true') {
    automaticAgeRatingVal = parseInt(age_rating || '0', 10);
  }

  return automaticAgeRatingVal;
};

export const stringFormatAgeRating = (
  ageRating: string,
  pin: string
): string => {
  if (parseInt(ageRating, 10) === -1) {
    return `{"age_rating":"", "pin":"${pin}"}`;
  } else {
    return `{"age_rating":"${ageRating}", "pin":"${pin}"}`;
  }
};

export const getParentalPopupDesc = (
  inputType: string,
  parentalStrings: {
    [key: string]: string;
  }
) => {
  let popupDesc;
  const loginType = getLocalStorage(TYPE_OF_LOGIN);
  const socialLoginType = getLocalStorage(SOCIAL_LOGIN_TYPE);
  const type =
    loginType === 'social' ? socialLoginType : loginType || inputType;
  switch (type) {
    case 'email':
      popupDesc = parentalStrings.WebLogin_Email_Text;
      break;
    case 'phoneno':
    case 'mobileLoginThroughOtp':
      popupDesc = parentalStrings.WebLogin_Mobile_Text;
      break;
    case 'facebook':
      popupDesc = parentalStrings.WebLogin_Title_AutenticateFacebook_Text;
      break;
    case 'twitter':
      popupDesc = parentalStrings.WebLogin_Title_AutenticateTwitter_Text;
      break;
    case 'google':
      popupDesc = parentalStrings.WebLogin_Title_AutenticateGoogle_Text;
      break;
    case 'apple':
      popupDesc = parentalStrings.WebLogin_Title_AutenticateAppStore_Text;
      break;
  }
  return popupDesc;
};

export const getSocialLoginType = (): string => {
  return getLocalStorage(SOCIAL_LOGIN_TYPE) || '';
};
